import { render, staticRenderFns } from "./SilenRenew.vue?vue&type=template&id=42b4a015&"
import script from "./SilenRenew.vue?vue&type=script&lang=js&"
export * from "./SilenRenew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports